import SettingsServer from '../../server/settings';
import { addLoading, removeLoading } from './loading';

export const setSettings = settings => ({
  type: 'SETTINGS_SET',
  settings,
});

export const loadSettings = () => async (dispatch) => {
  const settings = await SettingsServer.getSettings();
  dispatch(setSettings(settings));
};

export const loadSettingsLong = () => async (dispatch) => {
  const settings = await SettingsServer.getSettingsLong();
  return settings;
};

export const updateSettings = settings => async (dispatch) => {
  dispatch(addLoading());
  try {
    await SettingsServer.updateSettings(settings);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateSettingsLong = settingsLong => async (dispatch) => {
  dispatch(addLoading());
  try {
    await SettingsServer.updateSettingsLong(settingsLong);
  } finally {
    dispatch(removeLoading());
  }
};

export const importLogo = async (file, name) => SettingsServer.uploadLogo(file, name);
